module.exports = __webpack_public_path__ + "static/floral-department-coloring-page-fff28459f9424e8e2fdab7332f7f19dc.pdf";